// extend
export var CnSafeArea = function () { return null; };
